<template>
  <div
    class="flex h-full max-w-[340px] flex-col items-center justify-center gap-2 rounded-lg bg-steel-1100 px-10 py-8"
  >
    <img
      class="w-[68px] cursor-pointer"
      src="@/assets/highway-tfx-logo.svg"
      alt="highway badge"
    />

    <p class="text-center text-base text-white">
      Join TFX to unlock personalized recommendations
    </p>

    <ButtonComponent
      variant="primary"
      class="w-full"
    >
      Get Started
    </ButtonComponent>
  </div>
</template>

<script setup>
import { ButtonComponent } from '@/components';
</script>
